// extracted by mini-css-extract-plugin
export default {"spinner":"Image_spinner__fD3js","image":"Image_image__PXzyp","loaded":"Image_loaded__J0g-T","image-wrapper":"Image_image-wrapper__bZPq5"};